<div *ngFor="let opt of options" class="form-group radio-icon radio clearfix" data-test="type-selector">
  <input
    type="radio"
    class="radio-button"
    [class.disabled]="!opt.enabled"
    [name]="opt.name"
    [id]="opt.id"
    [value]="opt.value"
    [attr.data-test]="opt.dataTest"
    (change)="deliveryTypeChanged.emit($event.target.value)"
    [checked]="opt.value === deliveryType"
    [disabled]="!opt.enabled"
  />
  <label [for]="opt.name" class="inline-icon icon-radio-inactive" [class.disabled]="!opt.enabled">{{
    opt.displayName
  }}</label>
</div>
